import { useEffect } from 'react';
import { useQuery } from 'react-apollo';

import { usePageSpaceKey } from '@confluence/page-context';
import { markErrorAsHandled } from '@confluence/graphql';
import type {
	SpaceOperationsQueryType,
	SpaceOperationsQueryVariables,
} from '@confluence/entity-operations';
import { SpaceOperationsQuery } from '@confluence/entity-operations';

import { GetPromotedSpacesQuery } from './queries/GetPromotedSpacesQuery.experimentalgraphql';
import type {
	GetPromotedSpacesQuery as GetPromotedSpacesQueryType,
	GetPromotedSpacesQueryVariables,
} from './queries/__types__/GetPromotedSpacesQuery';

// TODO CCT-176: try removing these queries when fabric beta FF is enabled
export const CreateContentDataPreloader = () => {
	const [currentSpaceKey] = usePageSpaceKey();

	const { data: promotedSpaceData, error: promotedSpaceError } = useQuery<
		GetPromotedSpacesQueryType,
		GetPromotedSpacesQueryVariables
	>(GetPromotedSpacesQuery, {
		variables: {
			promotedSpaceKey: currentSpaceKey,
		},
	});

	const spaceKey = promotedSpaceData?.experimentalPromotedSpaces?.nodes?.[0]?.id || '';

	const { error: operationsError } = useQuery<
		SpaceOperationsQueryType,
		SpaceOperationsQueryVariables
	>(SpaceOperationsQuery, {
		variables: {
			spaceKey,
		},
		skip: !spaceKey,
	});

	useEffect(() => {
		// error will be reported if the user actually triggers a create via the handler
		markErrorAsHandled(promotedSpaceError);
		markErrorAsHandled(operationsError);
	}, [promotedSpaceError, operationsError]);

	return null;
};
